<template>
    <div class="row margenes">
        <!-- <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-10 col-sm-10 col-9">            
            <slot name="principal"></slot>
        </div> -->
        <div class="col-7">
            <slot name="principal"></slot>
        </div>
        <div class="col-5 table-container">
            <div class="tabla-wrapper">
                <table class="table table-modern">
                    <thead class="tabla-header">
                        <tr>
                            <th class="col-numero">#</th>
                            <th>Departamento</th>
                            <th>Municipio</th>
                            <th>Sede</th>
                        </tr>
                    </thead>
                    <tbody v-if="loader" class="text-center">
                        <tr>
                            <td colspan="4" class="loading-cell">
                                <b-spinner label="Cargando..." variant="primary"></b-spinner>
                                <span class="loading-text">Cargando ubicaciones...</span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else class="tabla-body">
                        <tr v-for="sede, index in sedes" :key="index" class="fila-sede">
                            <td class="numero-fila">{{ index + 1 }}</td>
                            <td class="departamento">{{ sede.municipio.departamento.nombre_dpto }}</td>
                            <td class="municipio">
                                <router-link :to="'/sedes/' + sede.municipio.id" class="enlace-municipio">
                                    {{ sede.municipio.mcpio }}
                                </router-link>
                            </td>
                            <td class="sede">
                                <router-link :to="'/mapa-bloques/' + sede.id + '/' + sede.municipio.id" class="enlace-sede">
                                    {{ sede.nombre }}
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
        
</template>
<script>
    import SemaforoConAlertas from '../Semaforo/SemaforoConAlertas.vue';
    import axios from 'axios';
    export default { 
        props: ['nombreAlerta', 'showSemaforo'], 
        components: {
            SemaforoConAlertas
        },
        data(){
            return{
                loader: true,
                sedes: [],
                visible: false
            }
        },
        mounted() {
            this.getSedes();
        },
        methods: {
            afterVisibleChange(val) {
                console.log('visible', val);
            },
            getSedes(){
                this.sedes = [];
                axios.get('/api/sedes', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.user.token}`
                    }
                })
                .then(res => {
                    // console.log(res.data)
                    this.sedes = res.data.sedes;
                    this.loader = false;
                    this.ordernarArray();
                })
                .catch(err => console.log(err))
            },
            ordernarArray(){
                this.sedes.sort((a, b) => {
                    if (a.municipio.departamento.nombre_dpto < b.municipio.departamento.nombre_dpto) return -1;
                    if (a.municipio.departamento.nombre_dpto > b.municipio.departamento.nombre_dpto) return 1;
                    return 0;
                });
            },
            showDrawer() {
                this.visible = true;
            },
            onClose() {
                this.visible = false;
            },
        },
        
    }
</script>
<style scoped>
    .margenes {
        padding: 20px;
    }

    .table-container {
        max-height: 85vh;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        border: 1px solid #e2e8f0;
        background: white;
    }

    .tabla-wrapper {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    /* Scrollbar personalizada */
    .tabla-wrapper::-webkit-scrollbar {
        width: 6px;
    }

    .tabla-wrapper::-webkit-scrollbar-track {
        background: #f7fafc;
    }

    .tabla-wrapper::-webkit-scrollbar-thumb {
        background: #cbd5e0;
        border-radius: 3px;
    }

    .tabla-wrapper::-webkit-scrollbar-thumb:hover {
        background: #a0aec0;
    }

    .table-modern {
        margin-bottom: 0;
        font-size: 0.9rem;
        border-collapse: separate;
        border-spacing: 0;
    }

    /* Header de la tabla */
    .tabla-header {
        position: sticky;
        top: 0;
        z-index: 10;
        background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
    }

    .tabla-header th {
        background: transparent !important;
        color: white !important;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.8rem;
        letter-spacing: 0.05em;
        padding: 1rem 0.75rem;
        border: none;
        text-align: left;
        white-space: nowrap;
    }

    .col-numero {
        width: 50px;
        text-align: center !important;
    }

    /* Cuerpo de la tabla */
    .tabla-body .fila-sede {
        background-color: #ffffff;
        transition: all 0.2s ease;
        border-bottom: 1px solid #e2e8f0;
    }

    .tabla-body .fila-sede:nth-child(even) {
        background-color: #f8fafc;
    }

    .tabla-body .fila-sede:hover {
        background-color: #edf2f7 !important;
        transform: translateX(2px);
        box-shadow: 4px 0 12px rgba(74, 85, 104, 0.1);
    }

    .tabla-body td {
        padding: 0.875rem 0.75rem;
        border: none;
        vertical-align: middle;
        color: #4a5568;
        font-weight: 500;
    }

    /* Columna de números */
    .numero-fila {
        background-color: #e2e8f0 !important;
        color: #2d3748 !important;
        font-weight: 600;
        text-align: center;
        border-radius: 6px;
        margin: 0.25rem;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.85rem;
        min-width: 32px;
    }

    /* Estilos para departamento */
    .departamento {
        font-weight: 600;
        color: #2d3748;
        font-size: 0.85rem;
    }

    /* Enlaces */
    .enlace-municipio,
    .enlace-sede {
        color: #4299e1;
        text-decoration: none;
        font-weight: 500;
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        transition: all 0.2s ease;
        display: inline-block;
        position: relative;
    }

    .enlace-municipio:hover,
    .enlace-sede:hover {
        color: #2b77c9;
        background-color: rgba(66, 153, 225, 0.1);
        text-decoration: none;
        transform: translateY(-1px);
    }

    .enlace-sede {
        color: #48bb78;
        font-weight: 600;
    }

    .enlace-sede:hover {
        color: #38a169;
        background-color: rgba(72, 187, 120, 0.1);
    }

    /* Estado de carga */
    .loading-cell {
        padding: 3rem 1rem;
        text-align: center;
        background: #f8fafc;
    }

    .loading-text {
        display: block;
        margin-top: 1rem;
        color: #718096;
        font-weight: 500;
        font-size: 0.9rem;
    }

    /* Responsive */
    @media screen and (max-width: 992px) {
        .alertas {
            display: none;
        }
        
        .table-container {
            max-height: 50vh;
        }
        
        .tabla-header th {
            font-size: 0.75rem;
            padding: 0.75rem 0.5rem;
        }
        
        .tabla-body td {
            padding: 0.75rem 0.5rem;
            font-size: 0.85rem;
        }
    }

    @media screen and (max-width: 768px) {
        .margenes {
            padding: 15px;
        }
        
        .table-container {
            max-height: 45vh;
        }
    }
</style>